import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Collapse,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MainCard from "../../components/Maincard";
import { useNavigate } from "react-router-dom";
import { useGetTokenOrLogout } from "../../utils/token";
import CustomAutocompleteComp from "../../newTestPrep/newComponent/AutocompleteComp";
import CustomSmallChip from "../../newTestPrep/newComponent/CustomChip/CustomSmallChip";
import CustomTextFieldComp from "../../newTestPrep/newComponent/customTextFieldComp";
import SearchButton from "../../newTestPrep/newComponent/NewButtonComp/SearchButton";
import ClearButtonComp from "../../newTestPrep/newComponent/NewButtonComp/ResetButtonComp";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../newTestPrep/newComponent/TableCustomeComp/CustomNoRowsOverlay";
import SearchTextFieldComp from "../../newTestPrep/newComponent/newtextfieldComp/SearchTextFieldComp";
import LoaderComp from "../../newTestPrep/newComponent/LoaderComp/Loader";
import CustomSnackbar from "../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import CustomPopup from "../../components/CustomPopup";
import CampaignEnquiryDetails from "./CampaignEnquiryDetails";
import { detectScrollType } from "@mui/utils/scrollLeft";

export default function CampaignWiseReport({ open }) {
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const userId = localStorage.getItem("userId");

  const getTokenOrLogout = useGetTokenOrLogout();
  const navigate = useNavigate();

  const [selectedButton, setSelectedButton] = useState(null);
  const [originalData, setOriginalData] = useState([]);
  const [campaignreportData, setCampaignreportData] = useState([]);
  const [campaignRowData, setcampaignRowData] = useState([]);

  const [campaignList, setCampaignList] = useState([]);
  const [campaignname, setCampaignName] = useState([]);
  const [selectedDuration, setSelectedDuration] = useState(null);
  const [eventFromDate, setEventFromDate] = useState(null);
  const [eventToDate, setEventToDate] = useState(null);
  const [loading, setloading] = useState(false);
  const [campaignLoading, setCampaignLoading] = useState(false);

  const [subServiceName, setSubServiceName] = useState([]);
  const [subServiceList, setSubsubServiceList] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");
  const [openDetails, setOpenDetails] = useState(false);
  const [DetailsLoading, setDetailsLoading] = useState(false);
  const [detailsData, setDetailsData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [headerName, setHeaderName] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedSubServiceName, setSeleteSubdServiceName] = useState([]);

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const noOptionsText = "Loading...";

  const years = Array.from(
    { length: 5 },
    (_, index) => new Date().getFullYear() - 3 + index
  );

  const [selectedYear, setSelectedYear] = useState(null);

  const handleselectedYear = async (value) => {
    setSelectedYear(value);

    getCampaignData(selectedButton, selectedDuration, value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subservice`);
        if (response.ok) {
          const data = await response.json();

          setSubsubServiceList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allSubservice = [{ name: "Select All", id: 0 }, ...subServiceList];

  // handle subservice
  const handleChangeSubservice = (id) => {
    setSelectedButton(null);
    setCampaignList([]);
    setCampaignName([]);
    setSelectedDuration(null);
    if (id === 0) {
      // Handle "Select All"
      setSubServiceName(
        (prevSelected) =>
          prevSelected.length === subServiceList.length
            ? [] // Deselect all
            : subServiceList.map((subservice) => subservice.id) // Select all
      );
    } else {
      // Handle individual subservice selection
      setSubServiceName(
        (prevSelected) =>
          prevSelected.includes(id)
            ? prevSelected.filter((subserviceId) => subserviceId !== id) // Remove ID if already selected
            : [...prevSelected, id] // Add ID if not selected
      );
    }
  };

  const handleChipClick = async (criteria) => {
    setSelectedButton(criteria);
    setCampaignList([]);
    setSelectedYear("");
    setCampaignName([]);
    setSelectedDuration("");
    setEventFromDate(null);
    setEventToDate(null);
  };

  const handlDurationchange = async (criteria) => {
    setSelectedYear("");
    setCampaignName([]);
    setCampaignList([]);
    setSelectedDuration(criteria);
    setEventFromDate(null);
    setEventToDate(null);
    if (criteria === "customyear" || criteria === "customdate") {
      return;
    }

    getCampaignData(selectedButton, criteria, null, null, null);
  };

  const handleChangeEventFromdate = (e) => {
    setEventFromDate(e.target.value);
  };
  const handleChangeEventTodate = (e) => {
    setEventToDate(e.target.value);
  };

  // useEffect(() => {
  //   if (eventFromDate !== "") {
  //     getCampaignData(
  //       selectedButton,
  //       selectedDuration,
  //       null,
  //       eventFromDate,
  //       eventToDate
  //     );
  //   }
  // }, [eventFromDate, eventToDate]);

  const handleCustomFilter = () => {
    getCampaignData(
      selectedButton,
      selectedDuration,
      null,
      eventFromDate,
      eventToDate
    );
  };

  const getCampaignData = async (
    selectedButton,
    duration,
    criteria,
    fromDate,
    toDate
  ) => {
    setloading(true);
    setCampaignName([]);
    setCampaignList([]);
    const requestData = {
      campaign_type: selectedButton,
      duration: duration,
      year: criteria,
      sub_service_id: subServiceName,
      from_date: fromDate,
      to_date: toDate,
    };

    try {
      const response = await fetch(`${API_ENDPOINT}route2.0/searchcampaign`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        setloading(false);
        const result = await response.json();
        const sortedData = result.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setCampaignList(sortedData);
      } else if (response.status === 401) {
        // Handle errors, e.g., show an error message
      } else if (response.status === 404) {
        setloading(false);
        setCampaignList([]);
      } else {
        setloading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setloading(false);
    }
  };

  const allcampaignList = [
    ...(campaignList.length > 1 ? [{ campaign_name: "Select All" }] : []),
    ...campaignList,
  ];

  const handleCampaignChange = (event, value) => {
    // Check if "Select All" is selected
    if (value.some((option) => option.campaign_name === "Select All")) {
      // If "Select All" is already selected, remove it from the selection
      if (
        campaignname.some((option) => option.campaign_name === "Select All")
      ) {
        setCampaignName([]);
      } else {
        // Otherwise, select all options
        setCampaignName(campaignList);
      }
    } else {
      setCampaignName(value);
    }
  };

  const handlechangeSubServiceName = (e, value) => {
    if (value.some((option) => option.name === "Select All")) {
      setSeleteSubdServiceName(subServiceList);
    } else {
      setSeleteSubdServiceName(value);
    }
  };

  const handleSearch = async (event) => {
    if (campaignname.length === 0) {
      showSnackbar("Please select campaign name first", "error");
      return;
    }

    setCampaignLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };

    const requestData = {
      campaign_id: campaignname.map((i) => i.id),
      from_date: fromDate || null,
      to_date: endDate || null,
      user_id: parseInt(userId),
      sub_service_id: selectedSubServiceName?.map((i) => i.id),
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}route2.0/filtercampaignreport-by-campaign`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const result = await response.json();
        const sortedData = result.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setCampaignreportData(sortedData);
        setOriginalData(sortedData);
        setcampaignRowData(sortedData);
        setCampaignLoading(false);
      } else if (response.status === 404) {
        navigate("/page404");
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/page403");
      } else if (response.status === 440) {
        navigate("/page440");
      } else {
        navigate("/page500");
      }
    } catch (error) {
      setCampaignLoading(false);
      navigate("/page500");
    }
  };

  const resetFilter = () => {
    setCampaignName([]);

    setCampaignreportData([]);
    setcampaignRowData([]);
    setSelectedButton("");
    setSelectedDuration("");
    setSelectedYear("");
    setCampaignList([]);

    setSubServiceName([]);
    setEventFromDate(null);
    setEventToDate(null);
    setFromDate("");
    setEndDate("");
    setSeleteSubdServiceName([]);
  };

  const columns = [
    {
      field: "campaign_id",
      headerName: "Campaign Name",
      flex: 2.3,
      minWidth: 500,

      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.campaign_id?.campaign_name || ""}`,

     renderCell: (params) => {
 const isLastRow=params.row?.campaign_id?.campaign_name==="Total"
 return (
        <div style={{
              color: isLastRow ? "black" : "",

              fontWeight: isLastRow ? 700 : 500,
            }}>{params.row?.campaign_id?.campaign_name} </div>
      )},
      headerAlign: "center",
      align: "center",
    },
    {
      field: "lead",
      headerName: "Leads",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
 const isLastRow=params.row?.campaign_id?.campaign_name==="Total"
 return (
        <div
          style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
          onClick={() =>isLastRow?undefined :  handleSearchDetails(params?.row, "leads", "Leads")}
        >
          {params.row?.lead}{" "}
        </div>
      )},
      headerAlign: "center",
      align: "center",
    },

    {
      field: "not_attempted",
      headerName: "Not Attempted",
      flex: 1,
      minWidth: 120,
      headerClassName: "header-cell",
       renderCell: (params) => {
 const isLastRow=params.row?.campaign_id?.campaign_name==="Total"
 return (
        <div
          style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
          onClick={() =>isLastRow?undefined :
            handleSearchDetails(params?.row, "not_attempted", "Not Attempted")
          }
        >
          {params.row?.not_attempted}{" "}
        </div>
      )},
      headerAlign: "center",
      align: "center",
    },
    {
      field: "enrolled",
      headerName: "Enrolled",
      flex: 1,
      minWidth: 120,
      headerClassName: "header-cell",
      renderCell: (params) => {
 const isLastRow=params.row?.campaign_id?.campaign_name==="Total"
 return (
        <div
       style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
          onClick={() =>isLastRow?undefined :
            handleSearchDetails(params?.row, "enrolled", "Enrolled")
          }
        >
          {params.row?.enrolled}{" "}
        </div>
      )},
      headerAlign: "center",
      align: "center",
    },

    {
      field: "recycled",
      headerName: "Recycled",
      flex: 1,
      minWidth: 120,
      headerClassName: "header-cell",
      renderCell: (params) => {
 const isLastRow=params.row?.campaign_id?.campaign_name==="Total"
 return (
        <div
        style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
          onClick={() =>isLastRow?undefined :
            handleSearchDetails(params?.row, "recycled", "Recycled")
          }
        >
          {params.row?.recycled}{" "}
        </div>
      )},
      headerAlign: "center",
      align: "center",
    },

    // {
    //   field: "not_enrolled",
    //   headerName: "Not Enrolled",
    //   width: 150,
    //   headerClassName: "header-cell",
    //   renderCell: (params) => (
    //     <div style={{ color: "blue", cursor: "pointer" }}>
    //       {params.row?.not_enrolled}{" "}
    //     </div>
    //   ),
    //   headerAlign: "center",
    //   align: "center",
    // },
  ];

  // search all column in datagrid
  const handleSearchByName = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = campaignRowData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data?.campaign_id?.campaign_name || ""}`,
        `${data?.lead || ""}`,
        `${data?.not_attempted}`,
        `${data?.enrolled}`,
        `${data?.recycled}`,

        `${data?.not_enrolled}`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value)
      );
    });

    setCampaignreportData(filteredData1); // Update the filtered data
  };

  const handleOpenPopup = (rowData, columnName, headerName) => {
    setOpenDetails(true);
    setHeaderName(headerName);
    setRowData(rowData);
  };

  const handleClosePopup = () => {
    setOpenDetails(false);
  };

  const handleSearchDetails = async (rowData, columnName, headerName) => {
    setDetailsLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };

    const requestData = {
      campaign_id: rowData?.campaign_id?.id,

      filter_for: columnName,
      from_date: fromDate || null,
      to_date: endDate || null,

      user_id: parseInt(userId),
      sub_service_id: selectedSubServiceName.map((i) => i.id),
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}route2.0/filtercampaignreport-by-campaign-with-detail`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const result = await response.json();
        const sortedData = result.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setDetailsData(sortedData);

        setDetailsLoading(false);
        handleOpenPopup(rowData, columnName, headerName);
      } else if (response.status === 401) {
        showSnackbar("Unknown User", "error");
        setDetailsLoading(false);
      } else {
        showSnackbar("Server Error", "error");
        setDetailsLoading(false);
      }
    } catch (error) {
      setDetailsLoading(false);
      showSnackbar("Server Error", "error");
    }
  };
  return (
    <>
      <LoaderComp isLoading={campaignLoading || DetailsLoading} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Collapse in={open} fullWidth>
            <MainCard>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={12} sm={12} md={12}>
                  <Typography
                    variant="h4"
                    sx={{
                      color: "#2E4069",

                      fontWeight: 600,
                      marginTop: "20px",
                    }}
                  >
                    Sub Service
                  </Typography>

                  {allSubservice.map((subservice) => (
                    <Chip
                      size="small"
                      key={subservice.id}
                      onClick={() => handleChangeSubservice(subservice.id)}
                      variant="outlined"
                      label={
                        subservice.id === 0
                          ? subServiceName.length === subServiceList.length
                            ? "Deselect All"
                            : "Select All"
                          : subservice.name
                      }
                      style={{
                        color: subServiceName.includes(subservice.id)
                          ? "green"
                          : "black",
                        fontSize: "0.7rem",
                        fontWeight: 500,
                        margin: "5px",
                        border: subServiceName.includes(subservice.id)
                          ? "2px solid green"
                          : "",
                      }}
                    />
                  ))}
                </Grid>

                <Grid item xs={12} lg={12} sm={12} md={12}>
                  <Typography
                    variant="h4"
                    sx={{ color: "#2E4069", fontWeight: 600 }}
                  >
                    Campaign Type
                    <span
                      style={{
                        color: "red",
                        fontSize: "15px",
                        marginLeft: "3px",
                      }}
                    >
                      *
                    </span>
                  </Typography>
                  <Box mt={1}>
                    <CustomSmallChip
                      label="All"
                      onClick={() => handleChipClick("all")}
                      isSelected={selectedButton === "all"}
                    />

                    <CustomSmallChip
                      label="Event"
                      onClick={() => handleChipClick("Event")}
                      isSelected={selectedButton === "Event"}
                    />

                    <CustomSmallChip
                      label="Generic"
                      onClick={() => handleChipClick("Generic")}
                      isSelected={selectedButton === "Generic"}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} lg={12} sm={12} md={12}>
                  <Typography
                    variant="h4"
                    sx={{
                      color: "#2E4069",

                      fontWeight: 600,
                    }}
                  >
                    Duration
                    <span
                      style={{
                        color: "red",
                        fontSize: "15px",
                        marginLeft: "3px",
                      }}
                    >
                      *
                    </span>
                  </Typography>
                  <Grid container>
                    <Box mt={1} sx={{ display: "flex", flexDirection: "row" }}>
                      <CustomSmallChip
                        label="All"
                        onClick={() => handlDurationchange("all")}
                        isSelected={selectedDuration === "all"}
                      />

                      <CustomSmallChip
                        label="Past"
                        onClick={() => handlDurationchange("past")}
                        isSelected={selectedDuration === "past"}
                      />

                      <CustomSmallChip
                        label="Running"
                        onClick={() => handlDurationchange("running")}
                        isSelected={selectedDuration === "running"}
                      />
                      <CustomSmallChip
                        label="Upcoming"
                        onClick={() => handlDurationchange("upcoming")}
                        isSelected={selectedDuration === "upcoming"}
                      />
                      {selectedDuration === "customyear" && (
                        <CustomAutocompleteComp
                          value={selectedYear}
                          onChange={(event, value) => handleselectedYear(value)}
                          sx={{ width: "300px" }}
                          options={years}
                        />
                      )}
                      <CustomSmallChip
                        label="Custom Date"
                        onClick={() => handlDurationchange("customdate")}
                        isSelected={selectedDuration === "customdate"}
                      />

                      {selectedDuration === "customdate" && (
                        <>
                          <CustomTextFieldComp
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            size="small"
                            sx={{ margin: "5px" }}
                            type="date"
                            label="From Date"
                            value={eventFromDate}
                            InputProps={{ style: { borderRadius: "14px" } }}
                            onChange={handleChangeEventFromdate}
                          />

                          <CustomTextFieldComp
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            size="small"
                            sx={{ margin: "5px" }}
                            type="date"
                            label="To Date"
                            value={eventToDate}
                            onChange={handleChangeEventTodate}
                            InputProps={{ style: { borderRadius: "14px" } }}
                          />

                          <Button
                            size="small"
                            color="primary"
                            variant="contained"
                            sx={{ margin: "5px" }}
                            onClick={handleCustomFilter}
                            disabled={!eventFromDate || !eventToDate}
                          >
                            Apply
                          </Button>
                        </>
                      )}
                    </Box>
                  </Grid>
                </Grid>

                <Grid item xs={12} lg={3} md={4} sm={12}>
                  <Typography variant="h6">Campaign</Typography>
                  <CustomAutocompleteComp
                    limitTags={1}
                    noOptionsText={
                      loading && allcampaignList.length === 0
                        ? noOptionsText
                        : "Please Select Above Filter First"
                    }
                    multiple
                    value={campaignname}
                    onChange={handleCampaignChange}
                    options={allcampaignList}
                    getOptionLabel={(option) => option.campaign_name}
                    tooltipContent={(option) => option.campaign_name}
                    endAdornment={
                      <>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                      </>
                    }
                  />
                </Grid>

                <Grid item xs={12} lg={3} md={4} sm={12}>
                  <Typography variant="h6">Sub Service</Typography>
                  <CustomAutocompleteComp
                    limitTags={1}
                    multiple
                    value={selectedSubServiceName}
                    onChange={handlechangeSubServiceName}
                    options={allSubservice}
                    getOptionLabel={(option) => option.name}
                    tooltipContent={(option) => option.name}
                  />
                </Grid>
                <Grid item xs={12} lg={2} md={3} sm={6}>
                  <Typography variant="h6">From Date</Typography>
                  <CustomTextFieldComp
                    fullWidth
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    size="normal"
                    type="date"
                    InputProps={{ style: { borderRadius: "10px" } }}
                  />
                </Grid>
                <Grid item xs={12} lg={2} md={3} sm={6}>
                  <Typography variant="h6">To Date</Typography>
                  <CustomTextFieldComp
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    fullWidth
                    size="normal"
                    type="date"
                    InputProps={{ style: { borderRadius: "10px" } }}
                  />
                </Grid>

                <Grid item xs={12} md={12} lg={12} sm={12} textAlign="end">
                  <Grid container gap={2} justifyContent="end">
                    <SearchButton
                      label="Get Campaign Wise  Report"
                      onClick={handleSearch}
                      showIcon={true}
                    />

                    <ClearButtonComp
                      label="Clear Report"
                      onClick={resetFilter}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </MainCard>
          </Collapse>
        </Grid>

        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item sm={12} md={6}>
                <Typography variant="h4"> Campaign Wise Report</Typography>
              </Grid>

              <Grid item sm={12} md={6} textAlign="end">
                <SearchTextFieldComp onChange={handleSearchByName} />
              </Grid>
              <Grid item xs={12}>
                <DataGrid
                  rows={campaignreportData}
                  columns={columns}
                  autoHeight
                  slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 25,
                      },
                    },
                  }}
                  pageSizeOptions={[25, 50, 100]}
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <CustomPopup
        open={openDetails}
        onClose={handleClosePopup}
        component={
          <CampaignEnquiryDetails
            onClose={handleClosePopup}
            data={detailsData}
            payLoadData={rowData}
            headerName={headerName}
            fromDate={fromDate}
            toDate={endDate}
            userReport={false}
          />
        }
        title={`Total ${
          headerName !== "Leads" ? headerName : ""
        } Enquiry Details`}
        maxWidth="lg"
        showDivider={true}
      />
    </>
  );
}
